import React from 'react';
import PropTypes from 'prop-types';

import { formatDate } from '../../../../utils/dateFunctions';
import CloseButton from '../../../formElements/CloseButton';
import StaticField from '../../../formElements/StaticField';

import form from '../../../../commonStyles/formStyles.module.css';
import expand from '../../../../commonStyles/rowExpand.module.css';

const HealthIncidentRowDetails = ({ row, onClose }) => {
    return (
        <div className={expand.rowDropdown}>
            <form className={form.formWrapper}>
                <div className={form.formSection}>
                    <div className={form.formColumn}>
                        <StaticField
                            id="fibreSupplementDate"
                            label="Fibre Supplement Date"
                            content={formatDate(row.fibreSupplementDate) || ' - '}
                            customClass="dateInfo"
                        />

                        <StaticField
                            id="capillaryBloodGlucoseFlagDate"
                            label="Capillary Blood Glucose Flag Date"
                            content={formatDate(row?.capillaryBloodGlucoseFlagDate) || ' - '}
                            customClass="dateInfo"
                        />

                        <StaticField
                            id="bloodPressureFlagDate"
                            label="Blood Pressure Flag Date"
                            content={formatDate(row?.bloodPressureFlagDate) || ' - '}
                            customClass="dateInfo"
                        />

                        <StaticField
                            id="note"
                            label="Notes"
                            content={row.note || ' - '}
                            customClass="info"
                        />

                        {row.sideEffectsDetail && (
                            <StaticField
                                id="sideEffectsDetail"
                                label="Other - Side Effect Event Type Details"
                                content={row.sideEffectsDetail}
                                customClass="info"
                            />
                        )}
                    </div>
                    <div className={form.formColumn}>
                        <StaticField
                            id="uniqueAlertsToPrimaryCare"
                            label="No. Unique Alerts to Primary Care"
                            content={row.uniqueAlertsToPrimaryCare || ' - '}
                            customClass="info"
                        />

                        <StaticField
                            id="uniqueAlertsDate"
                            label="Unique Alerts Date"
                            content={formatDate(row?.uniqueAlertsDate) || ' - '}
                            customClass="dateInfo"
                        />

                        <StaticField
                            id="alertsDiscussedWithMedicalDirector"
                            label="Alerts Discussed with Medical Director"
                            content={row?.alertsDiscussedWithMedicalDirector ? 'Yes' : 'No'}
                            customClass="info"
                        />

                        <StaticField
                            id="linkedModule"
                            label="Linked Module"
                            content={row.linkedModule || ' - '}
                            customClass="info"
                        />

                        {row.adverseEventsDetail && (
                            <StaticField
                                id="adverseEventsDetail"
                                label="Other - Adverse Event Event Type Details"
                                content={row.adverseEventsDetail}
                                customClass="info"
                            />
                        )}
                    </div>
                </div>
            </form>
            <CloseButton id="healthIncidentRowDetailButton" onClose={onClose} />
        </div>
    );
};

HealthIncidentRowDetails.propTypes = {
    row: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired
};

export default HealthIncidentRowDetails;
